import {
  CREATE_ATTRIBUTE_FAILURE,
  CREATE_ATTRIBUTE_REQUEST,
  GET_ALL_ATTRIBUTE_REQUEST,
  GET_ALL_ATTRIBUTE_SUCCESS,
  GET_ALL_ATTRIBUTE_FAILURE,
  DELETE_ATTRIBUTE_REQUEST,
  DELETE_ATTRIBUTE_FAILURE,
  UPDATE_ATTRIBUTE_REQUEST,
  UPDATE_ATTRIBUTE_FAILURE,
  DELETE_ATTRIBUTE_SUCCESS,
} from "./ActionType";

const initialState = {
  attributes: [],
  loading: false,
  error: "",
};

export const vendorProductAttributeReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_ATTRIBUTE_REQUEST:
      return { ...state, loading: true };

    case CREATE_ATTRIBUTE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case GET_ALL_ATTRIBUTE_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_ATTRIBUTE_SUCCESS:
      return { ...state, loading: false, error: "", attributes: action.payload };

    case GET_ALL_ATTRIBUTE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_ATTRIBUTE_REQUEST:
      return { ...state, loading: true };

    case DELETE_ATTRIBUTE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        attributes: state.attributes?.response?.filter(attr => attr.id !== action.payload)
      };

    case DELETE_ATTRIBUTE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_ATTRIBUTE_REQUEST:
      return { ...state, loading: true };

    case UPDATE_ATTRIBUTE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
